import React from 'react'
import { FooterSection } from '../../elements/FooterSection'
import { TextLink } from '../TextLink'
import { Text } from '../../elements/Text'
import { FooterBlogLinks as FooterBlogLinksDefault } from './component'
import { BrandOptions, useBrand } from '../../providers/brandProvider'
import useFetchNewsUpdates from 'marketing-site/lib/useFetchNewsUpdates'
import useTranslate from '../../hooks/useTranslate'

export const FooterBlogLinks = (): React.ReactElement => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <FooterBlogLinksDefault />
  }
  return <FooterBlogLinksLegacy />
}

export function FooterBlogLinksLegacy(): React.ReactElement {
  const links = useFetchNewsUpdates(4)
  const { translate } = useTranslate()
  return (
    <>
      {/* TODO this heading also needs translation */}
      <FooterSection heading={translate('From the blog')} links={links} />
      <div className="footer__link footer__link--blog">
        <TextLink url="https://www.intercom.com/blog">
          <Text brand="legacy" size="body">
            {translate('Read more')}
          </Text>
        </TextLink>
      </div>
    </>
  )
}
